import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { ROLE_OWNER } from "@/lib/utils";
import { routes } from "@/routes/utils";

const OwnerProtectedRoute = () => {
  const currentRole = useSelector(
    (state: RootState) => state.currentData.currentRole
  );

  const isOwner = currentRole === ROLE_OWNER;

  if (!isOwner) {
    return <Navigate to={`/${routes.owner}/${routes.dashboard}`} replace />;
  }

  return <Outlet />;
};

export default OwnerProtectedRoute;
